import React, { useState, useEffect } from 'react'
import { Close } from '@material-ui/icons'

import {
  Card,
  CardContent,
  IconButton,
  Grid,
  Button,
  FormControl,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  Chip,
} from '@material-ui/core'
import { updateAssignedShopIdList } from '../../actions/shop'

export default function LabelDialog(props) {
  const { label, onClose, open, shops, dispatch, onUpdated, companyId } = props

  const [assignedTo, setAssignedTo] = useState([])
  const [filteredShops, setFilteredShops] = useState([])

  useEffect(() => {
    if (label) {
      if (label.assignedShops && label.assignedShops[companyId]) {
        if (label.assignedShops[companyId] != assignedTo)
          setAssignedTo(label.assignedShops[companyId] || [])
      }
      if (shops && shops.length > 0) {
        let filteredShops = []
        if (label.restricted) {
          if (
            label.assignedCompanies &&
            label.assignedCompanies.length > 0 &&
            label.assignedCompanies.includes(companyId)
          ) { //restricted with company allows all shops
            filteredShops = shops
          } else if (label.allowedStates && label.allowedStates.length > 0) {
            filteredShops = shops.filter((shop) => {
              const state = shop.address && shop.address.state
              return state && label.allowedStates.includes(state)
            })
          }
        } else {
          filteredShops = shops
        }
        setFilteredShops(filteredShops)
      }
    }
  }, [props.label])

  const handleAssignedToChange = (event) => {
    setAssignedTo(() => event.target.value)
  }

  const deleteAssignedTo = (value) => {
    setAssignedTo((assignedTo) => assignedTo.filter((el) => el !== value))
  }

  const getShopName = (id) => {
    for (let el of shops) if (id == el.id) return el.name
    return null
  }

  const updateAssignedShopsList = async () => {
    await dispatch(updateAssignedShopIdList(label.id, assignedTo))
    onUpdated()
    closeDialog()
  }

  const labelDialogClassName = () => {
    if (!open) return 'label-dialog'
    return 'label-dialog active'
  }

  const closeDialog = () => {
    setAssignedTo([])
    onClose()
  }

  const isLabelRestrictedWithStates = () => {
    return label && label.restricted && label.allowedStates && label.allowedStates.length > 0
  }

  const getAllowedStates = () => {
    if (isLabelRestrictedWithStates()) {
      return label.allowedStates.join(', ')
    }
    return ''
  }

  return (
    <Card className={labelDialogClassName()}>
      {open ? <div className="overlay" /> : null}
      <IconButton onClick={closeDialog} style={{ marginTop: '20px', marginLeft: '10px' }}>
        <Close />
      </IconButton>
      <CardContent style={{ paddingTop: '0' }}>
        <h1 className="title">{label && label.labelName}</h1>
        <center>
          <img
            src={label && label.templateThumbnail && label.templateThumbnail.largeURL}
            className="label-img"
          />
        </center>
        <form action="">
          <div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Name</p>
              <span>{label && label.labelName}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Description</p>
              <span>{label && label.description}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Label Type</p>
              <span>{label && label.labelType}</span>
            </div>
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Size</p>
              <span>{label && `${label.width}" x ${label.height}"`}</span>
            </div>
            {isLabelRestrictedWithStates() && <div className="dialog-section">
              <p className="font-weight-bold subtitle">Allowed States</p>
              <span>{getAllowedStates()}</span>
            </div>}
            <div className="dialog-section">
              <p className="font-weight-bold subtitle">Assigned To</p>
              <FormControl fullWidth>
                <Select
                  multiple
                  value={assignedTo}
                  onChange={handleAssignedToChange}
                  // input={<Input rowsMax="5" />}
                  renderValue={(selected) =>
                    assignedTo
                      .filter((value) => getShopName(value) != null)
                      .map((value) => (
                        <Chip
                          key={value}
                          label={getShopName(value)}
                          color="primary"
                          style={{ color: 'white' }}
                          deleteIcon={<Close style={{ color: 'white' }} />}
                          onDelete={() => deleteAssignedTo(value)}
                          hidden
                        />
                      ))
                  }
                >
                  {filteredShops.map((shop) => (
                    <MenuItem key={shop.id} value={shop.id}>
                      <Checkbox
                        color="primary"
                        readOnly
                        checked={assignedTo && assignedTo.indexOf(shop.id) > -1}
                      />
                      <ListItemText primary={shop.name} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
          </div>
          <div className="dialog-section">
            <Grid container justify="space-between">
              <Grid item>
                <Button style={{ color: '#F25E3D' }} className="dialog-action" onClick={onClose}>
                  Cancel
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  variant="contained"
                  className="dialog-action"
                  onClick={updateAssignedShopsList}
                >
                  Update / Save
                </Button>
              </Grid>
            </Grid>
          </div>
        </form>
      </CardContent>
    </Card>
  )
}



// WEBPACK FOOTER //
// ./src/components/Modal/LabelDialog.js